import { Link } from 'react-router-dom';
import { comics, hotComicIds } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotSection() {
  const hotComics = hotComicIds
    .map((id) => comics.find((c) => c.id === id))
    .filter(Boolean) as NonNullable<ReturnType<typeof comics.find>>[];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div className="flex items-baseline gap-3">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <i className="ri-fire-line text-xl md:text-2xl text-primary-500"></i>
          </div>
          <Link
            to="/category/korean"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看更多 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          {hotComics.slice(0, 3).map((comic) => (
            <ComicCard key={comic.id} comic={comic} variant="featured" />
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mt-5">
          {hotComics.slice(3).map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}